import React from "react";
import Card from "../common/Card";
import Icon from "../common/Icon";
import Tooltip from "./Tooltip";
import "./LeaderTable.css";

const LeaderTable = ({
  title,
  data,
  valueLabel,
  linkText,
  onViewAll,
  tooltipText,
  onViewMore,
}) => {
  return (
    <Card className="leader-table">
      <div className="leader-table-header">
        {tooltipText ? (
          <Tooltip text={tooltipText}>
            <h3 className="leader-table-title">{title}</h3>
          </Tooltip>
        ) : (
          <h3 className="leader-table-title">{title}</h3>
        )}
        {linkText && (
          <button className="leader-table-link" onClick={onViewAll}>
            {linkText}
            <Icon name="ExternalLink" size={14} />
          </button>
        )}
      </div>

      <div className="leader-table-content">
        {data && data.length > 0 ? (
          <ul className="leader-list">
            {data.map((item, index) => (
              <li key={index} className="leader-item">
                <span className="leader-rank">#{item.rank}</span>
                <span className="leader-domain">{item.domain}</span>
                <span className="leader-value">{item.value}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="leader-empty">Aucune donnée disponible</p>
        )}
      </div>

      {onViewMore && data && data.length > 0 && (
        <div className="leader-table-footer">
          <button className="leader-view-more-btn" onClick={onViewMore}>
            Voir plus
            <Icon name="ChevronRight" size={16} />
          </button>
        </div>
      )}
    </Card>
  );
};

export default LeaderTable;
